import { useEffect } from 'react'
import { withRouter } from 'react-router-dom';

function ScrollToTop({ data }) {
    useEffect(() => {
        if (window.scrollY > 20) window.scrollTo(0, 0);
    }, [data]);
    return (null);
}
export default withRouter(ScrollToTop)
